// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class DocumentReloadRequests {
    async GetInitData() {
        return await SmrClient.FetchJson({
            url: 'DocumentReload/GetInitData',
            method: 'GET'
        });
    }

    /**
     * @param {DocumentDownloadFilterSet} filters 
     * @returns {Promise<WebRecords<WebDocumentReloadData>>}
     */
    async GetData(filters) {
        return await SmrClient.FetchJson({
            url: 'DocumentReload/GetData',
            method: "POST",
            body: filters
        });
    }

    /**
     * @param {WebDocumentReloadData} dataToSend 
     * @returns {Promise<DocumentReloadState>}
     */
    async ReloadDocument(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'DocumentReload/ReloadDocument',
            method: "POST",
            body: dataToSend
        });
    }
}

export default new DocumentReloadRequests;